/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Costume Type
 */
export enum CostumeType {
    Standard = 'Standard',
    EveningWear = 'Evening Wear',
    PeriodWear = 'Period Wear',
}
